import React from 'react'
import { RichText as PrismicRichText } from 'prismic-reactjs'
import { FeaturedListSlice } from 'modules/prismic'
import { Wrapper, Row } from './styled'

export const FeaturedList = ({ primary, items }: FeaturedListSlice) => {
  const { heading } = primary

  return (
    <Wrapper>
      {PrismicRichText.render(heading)}
      {items.map((item, idx) => {
        const { icon, content, align_content_to_right: alignContentToRight } = item
        return (
          <Row key={idx} alignContentToRight={alignContentToRight}>
            {icon.url && (
              <img src={icon.url} alt={icon.alt ?? ''} width={icon.dimensions?.width} height={icon.dimensions?.height} />
            )}
            {PrismicRichText.render(content)}
          </Row>
        )
      })}
    </Wrapper>
  )
}
